export default __webpack_public_path__ + "static/media/mtt1.feffb8d5.jpg";